import { ReducerActions } from '../models/reducers/ReducerType';

type Dispatch = (action: ReducerActions) => void;

export const errorDispatcher = (error: Error, dispatch: Dispatch): void => {
    if (error?.message === ('Error: NOINTERNET' || 'Network error')) {
        return dispatch({ type: 'NETWORK' })
    }
    return dispatch({ type: 'FAILURE', error: error });
}